var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C12218",
    d: "M7 1.667a5.333 5.333 0 1 0 0 10.666A5.333 5.333 0 0 0 7 1.667M.333 7a6.667 6.667 0 1 1 13.334 0A6.667 6.667 0 0 1 .333 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C12218",
    d: "M7 8.333a.667.667 0 0 1-.667-.666v-4a.667.667 0 0 1 1.334 0v4A.667.667 0 0 1 7 8.333M6 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
};
export default SvgError;